import { useTranslation } from "react-i18next";
import { Form, Icon } from "semantic-ui-react";

import { Element } from "components/ReactScroll/index";
import { createFormHelper } from "lib/Form";

import type { DealerAdminFormPayload } from "modules/DealerDetails";

const FormHelper = createFormHelper<DealerAdminFormPayload>();

const MAX_RETENTION_IN_YEARS = 20;
const retentionDropdownOptions = Array.from({ length: MAX_RETENTION_IN_YEARS }, (_, idx) => ({ key: idx + 1, value: idx + 1, text: `${idx + 1}` }));

type GdprAvgProps = {
  tabId: string;
};

export const GdprAvg = ({ tabId }: GdprAvgProps) => {
  const { t } = useTranslation();

  return (
    <Element name={tabId} className="dealer-details-section">
      <div className="section-title">
        <div>
          <Icon className="shield halved" />
        </div>
        <span className="section-title-text">{t("v8_gdpr_avg", "GDPR - AVG")}</span>
      </div>
      <div className="dealer-details-subheading">{t("v8_gdpr_avg", "GDPR - AVG")}</div>
      <Form.Group>
        <Form.Field width={8}>
          <label>{t("v8_customer_data_retention_period_in_years", "Customer data retention period (in years)")}</label>
          <FormHelper.Field.Dropdown name="customer_data_retention_in_years" options={retentionDropdownOptions} />
        </Form.Field>
      </Form.Group>
    </Element>
  );
};
